// redirectSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RedirectState {
  itemIdForRedirect: number | null;
  oldId: number | null;
}

const initialState: RedirectState = {
  itemIdForRedirect: null,
  oldId: null
};

const redirectSlice = createSlice({
  name: "redirect",
  initialState,
  reducers: {
    setItemIdForRedirect: (state, action: PayloadAction<RedirectState>) => {
      state.itemIdForRedirect = action.payload.itemIdForRedirect;
      state.oldId = action.payload.oldId
    },
  },
});

export const { setItemIdForRedirect } = redirectSlice.actions;
export default redirectSlice.reducer;
